import {getFormMessages} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {useAppSelector} from '../../../hooks/runtime'
import {getEvent} from '../../../selectors/event'
import {RsvpInfoButton} from '../rsvp-info-button/rsvp-info-button'
import {TicketsUnavailableButtonProps} from './interfaces'

export const TicketsUnavailableButton: React.FC<TicketsUnavailableButtonProps> = ({href}) => {
  const event = useAppSelector(getEvent)
  const {ticketsUnavailable} = getFormMessages(event)

  return <RsvpInfoButton messages={ticketsUnavailable} dataHook={DH.TICKETS_UNAVAILABLE} href={href} />
}
